/**
 * Generic move list typings
 */
export namespace MoveList {
  export type Translations = {
    [key in
      | Translation.Actions
      | Translation.Annotations
      | Translation.Pieces
      | Translation.Prompt
      | Translation.Tooltips
      | Translation.Plural
      | Translation.GameTerminationMessages]: (substitution?: any) => string;
  };

  export namespace Translation {
    export enum Actions {
      ClearAllAnalysis = 'Clear All Analysis',
      DeleteCommentAfter = 'Delete Comment After',
      DeleteCommentBefore = 'Delete Comment Before',
      DeleteComment = 'Delete Comment',
      DeleteLine = 'Delete Entire Variation',
      DeleteMove = 'Delete Move',
      InsertComment = 'Comment',
      InsertCommentAfter = 'Comment After',
      InsertCommentBefore = 'Comment Before',
      InsertContinuation = 'Insert Continuation',
      MoveVariationDown = 'Move Variation Down',
      MoveVariationUp = 'Move Variation Up',
      Promote = 'Promote',
      RemoveAnnotation = 'Remove Annotation',
      ShowAllAnnotations = 'Show All Annotations',
      HideAllAnnotations = 'Hide All Annotations',
      // diagram actions
      RemoveBegin = 'Remove Begin',
      RemoveEnd = 'Remove End',
      RemoveEvaluationAnnotation = 'Remove Evaluation Annotation',
      RemoveFocus = 'Remove Focus',
      SetBegin = 'Set Begin',
      SetEnd = 'Set End',
      SetFocus = 'Set Focus',
    }

    export enum Annotations {
      BadMove = 'Bad move',
      BlackHasDecisiveAdvantage = 'Black has a decisive advantage',
      BlackHasModerateAdvantage = 'Black has a moderate advantage',
      BlackHasSlightAdvantage = 'Black has a slight advantage',
      Blunder = 'Blunder',
      Drawish = 'Drawish',
      DubiousMove = 'Dubious move',
      ExcellentMove = 'Excellent move',
      GoodMove = 'Good move',
      Miss = 'Miss',
      Novelty = 'Novelty',
      Unclear = 'Unclear',
      PositionInZuqZwang = 'The position is in zugzwang',
      SpeculativeMove = 'Speculative move',
      WhiteHasSlightAdvantage = 'White has a slight advantage',
      WhiteHasModerateAdvantage = 'White has a moderate advantage',
      WhiteHasDecisiveAdvantage = 'White has a decisive advantage',
      WithInitiative = 'With initiative',
      WithCompensation = 'With compensation',
      WithAttack = 'With an attack',
      TimeTrouble = 'Time trouble',
      Counterplay = 'Counterplay',
      DevelopmentLead = 'Development lead',
    }

    export enum Pieces {
      B = 'B',
      K = 'K',
      N = 'N',
      P = 'P',
      Q = 'Q',
      R = 'R',
    }

    export enum Plural {
      NumberOfDays = 'numberOfDays',
      NumberOfHours = 'numberOfHours',
      NumberOfMinutes = 'numberOfMinutes',
    }

    export enum Prompt {
      AddComment = 'Add Comment...',
    }

    export enum Tooltips {
      FiftyMove = 'Fifty moves were played with no capture or pawn move, so the game ended in a draw.',
      InsufficientMaterial = 'Neither player had enough material to force checkmate, so the game ended in a draw.',
      WhiteTimeoutVsInsufficientMaterial = 'Although White ran out of time, Black did not have sufficient material to ever force checkmate, so the game ended in a draw.',
      BlackTimeoutVsInsufficientMaterial = 'Although Black ran out of time, White did not have sufficient material to ever force checkmate, so the game ended in a draw.',
      DrawByAgreement = 'The game has been drawn by agreement.',
      Stalemate = 'A draw by stalemate occurs when the player whose turn it is has no legal moves, but their king is not in check.',
      EnPassant = 'En passant is a special pawn move by which a pawn captures another pawn that has advanced two squares.',
      ThreeFoldRepetition = 'This game ended in a draw because the same position was repeated three times.',
    }

    export enum GameTerminationMessages {
      TimeoutVsInsufficientMaterial = 'Game drawn by timeout vs insufficient material',
      DrawByAgreement = 'Game drawn by agreement',
    }
  }

  export const enum Types {
    HML = 'hml',
    VML = 'vml',
    MOVE_LIST = 'move-list',
  }
}
